import sprints from './sprints'
import stories from './stories'
import epics from './epics'
import tasks from './tasks'
import stages from './stages'
import effort from './effort'
import tags from './tags'
import backlog from './backlog'

export default {
  sprints,
  stories,
  backlog,
  epics,
  tasks,
  stages,
  effort,
  tags
}
